export const isDevelopment = import.meta.env.MODE === 'development';
// Toggles OnePortal related UI changes. Enabled for local dev and integ, disabled for lab/staging/prod.
export const FEATURE_ONEPORTAL = import.meta.env.VITE_FEATURE_ONEPORTAL === 'true';

export const TENANT_MAX_IMAGE_SIZE = 500 * 1024;
export const TENANT_MIN_IMAGE_SIZE = 1024;
export const TENANT_MAX_PDF_SIZE = 5 * 1024 * 1024;
export const TENANT_MIN_PDF_SIZE = 1024;
export const APP_VERSION = __APP_VERSION__;
export const MAX_NON_CASH_MONTHLY_BUDGET_CENTS = 5000;
export const BIKELEASING_INSURANCE_PLAN_URL = `${import.meta.env.VITE_BIKELEASING_PIM_URL}/get-asset/dokumente-und-informationen/Ablauf%20AGAV%20Grafik_Stand112021.pdf`;
export const BIKELEASING_FAQ_URL = `${import.meta.env.VITE_BIKELEASING_URL}/faq`;
export const BIKELEASING_INSURANCE_URL = `${import.meta.env.VITE_BIKELEASING_PIM_URL}/get-asset/PDF/DE/Versicherungshandbuch.pdf`;
export const BIKELEASING_DAMAGE_URL = `${import.meta.env.VITE_BIKELEASING_PIM_URL}/get-asset/PDF/EN/ablauf_im_schadensfall.pdf`;
export const MARKETING_CONSENT_GIVEN_QUERY = 'marketingConsentGiven';
